export { default as PageTips } from './pageTips';
